import { render, staticRenderFns } from "./ProductCount.vue?vue&type=template&id=07187d52&scoped=true"
import script from "./ProductCount.vue?vue&type=script&lang=js"
export * from "./ProductCount.vue?vue&type=script&lang=js"
import style0 from "./ProductCount.vue?vue&type=style&index=0&id=07187d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07187d52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
